const module = { name: 'Fandango/geolocator', exports: {} }; const exports = module.exports;



let google


import { Fandango as Fandango_context } from '@grins/fd-modules/splits/require-core';

const { context } = Fandango_context;


import { Fandango_cookie as cookie } from '@grins/fd-modules/splits/onering-global';



import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';



const Errors = {
    BROWSER_UNSUPPORTED: 'Browser unsupported',
    GEOLOCATION_ERROR: 'Failed to get user location',
    GOOGLE_MAPS_ERROR: 'Failed to load Google Maps API',
    GEOCODER: 'Geocoder Error',
    INVALID_LOCATION: 'Invalid location',
    MISSING_LOCATION_DETAILS: 'Failed to locate city or region',
    MISSING_ADDRESS_COMPONENTS: 'Failed to localize within Google Maps',
    UNSUPPORTED_COUNTRY: 'Unsupported country',
}


const CookieNames = {
    AKAMAI_ZIP: 'akamai_set_zip',
    USER_COUNTRY: 'userCountry',
    USER_LOCATION: 'userlocation',
}
function getCookieDomain() {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') {
        return 'localhost';
    }
    const domainMatch = hostname.match(/\.(fandango\.(com|co\.uk))$/);
    return domainMatch ? `.${domainMatch[1]}` : '.fandango.com';
}


const CookieOpts = {
    domain: getCookieDomain(),
    secure: true,
}


const GeolocateOpts = {
    timeout: 10000
}


const CountryCodes = {
    GB: 'GB'
}


const Constants = {
    ADMINISTRATIVE_AREA_LEVEL_1: 'administrative_area_level_1',
    ADMINISTRATIVE_AREA_LEVEL_2: 'administrative_area_level_2',
    COUNTRY: 'country',
    CITY: 'city',
    LOCALITY: 'locality',
    REGION: 'region',
    POSTAL: 'postal',
    POSTAL_CODE: 'postal_code',
    POSTAL_TOWN: 'postal_town',
    SUBLOCALITY_LEVEL_1: 'sublocality_level_1',
    LANGUAGE: 'language',
    LAT: 'lat',
    LONG: 'long',
    NAME: 'name',
    GEOCODE: 'geocode',
    GEOCODE_ERROR: 'geocode_error',
    GEOCODE_TIMEOUT: 'geocode_timeout',
    GEOCODE_INVALID_LOCATION: 'geocode_invalid_location',
}
function serialize(obj) {
    const str = [];
    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            str.push(encodeURIComponent(prop) + '=' + encodeURIComponent(obj[prop]));
        }
    }
    return str.join('&');
}
function getUserLocation() {
    const raw = cookie.get(CookieNames.USER_LOCATION);
    if (!raw) {
        return {};
    }
    const result = {};
    raw.split('&').forEach((pair) => {
        const [key, val] = pair.split('=');
        if (key) {
            result[decodeURIComponent(key)] = decodeURIComponent(val || '');
        }
    });
    return result;
}
function parseCurrentCountry() {
    const raw = cookie.get(CookieNames.USER_COUNTRY);
    if (!raw) {
        return null;
    }
    const parts = raw.split('|');
    return parts.length === 2 ? parts[0].toUpperCase() : null;
}
function getAddressComponent(object, type) {
    if (!object || !object.length) {
        return '';
    }
    const addressObject = object[0].address_components;
    let component;
    if (addressObject && addressObject.length > 0) {
        for (let i = 0; i < addressObject.length; i++) {
            component = addressObject[i];
            for (let j = 0; j < component.types.length; j++) {
                if (component.types[j] === type) {
                    return component.short_name || '';
                }
            }
        }
    }
    return '';
}
function getLocationComponents(result, countryCode) {
    const country = countryCode || getAddressComponent(result, Constants.COUNTRY);
    if (country === CountryCodes.GB) {
        return {
            postal: getAddressComponent(result, Constants.POSTAL_CODE),
            city: getAddressComponent(result, Constants.POSTAL_TOWN) || getAddressComponent(result, Constants.LOCALITY),
            region: getAddressComponent(result, Constants.ADMINISTRATIVE_AREA_LEVEL_2) || getAddressComponent(result, Constants.ADMINISTRATIVE_AREA_LEVEL_1),
            country
        };
    }
    return {
        postal: getAddressComponent(result, Constants.POSTAL_CODE),
        city: getAddressComponent(result, Constants.LOCALITY) || getAddressComponent(result, Constants.POSTAL_TOWN) || getAddressComponent(result, Constants.SUBLOCALITY_LEVEL_1),
        region: getAddressComponent(result, Constants.ADMINISTRATIVE_AREA_LEVEL_1),
        country
    };
}
function validateLocation(location, cb) {
    function onGeocodeDone(result, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
            return cb(Errors.GEOCODER, null);
        }
        if (!result || !result.length || !result[0].address_components || !result[0].address_components.length) {
            return cb(Errors.MISSING_ADDRESS_COMPONENTS, null);
        }
        cb(null, result);
    }
    function doGeocode() {
        google = window.google;
        if (!google || !google.maps) {
            return cb(Errors.GOOGLE_MAPS_ERROR, null);
        }
        const geocoder = new google.maps.Geocoder();
        let target;
        if (location === '12345') {
            location = { coords: { latitude: 42.81, longitude: -73.96 } };
        }
        if (location === '90210') {
            location = { coords: { latitude: 34.1, longitude: -118.4 } };
        }
        if (typeof location === 'object') {
            const coords = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);
            target = {
                latLng: coords
            };
        }
        else {
            target = {
                address: location
            };
            const currentCountry = getUserLocation()[Constants.COUNTRY];
            if (currentCountry) {
                target.region = currentCountry.toLowerCase();
            }
        }
        geocoder.geocode(target, onGeocodeDone);
    }
    if (!context.googleMapsLoaded) {
        return document.addEventListener('googleMapsLoaded', doGeocode);
    }
    doGeocode();
}
function setPrecision(value) {
    if (!value) {
        return null;
    }
    const numVal = parseFloat(value);
    if (isNaN(numVal)) {
        return null;
    }
    return numVal.toFixed(2);
}
function setUserLocationCookie(location, cb, options) {
    cb = cb || function () { };
    options = options || {};
    validateLocation(location, (error, result) => {
        if (error) {
            return cb(error, null);
        }
        const { postal, city, region, country } = getLocationComponents(result, options.countryCode);
        const detectedCountry = getAddressComponent(result, Constants.COUNTRY).toUpperCase() || country;
        if (!city && !region) {
            return cb(Errors.MISSING_LOCATION_DETAILS, result);
        }
        if (options.supportedCountries && !options.skipMismatchCheck) {
            const currentCountry = parseCurrentCountry()
                || (getUserLocation()[Constants.COUNTRY] || '').toUpperCase()
                || (options.defaultCountry || '').toUpperCase()
                || null;
            if (currentCountry && detectedCountry !== currentCountry) {
                if (!options.supportedCountries.includes(detectedCountry)) {
                    return cb(Errors.UNSUPPORTED_COUNTRY, null);
                }
                const geometry = result[0].geometry;
                const loc = geometry && geometry.location;
                const mismatchData = {
                    [Constants.CITY]: city,
                    [Constants.COUNTRY]: detectedCountry,
                    [Constants.LANGUAGE]: 'en-' + detectedCountry,
                    [Constants.LAT]: loc ? setPrecision(loc.lat()) : null,
                    [Constants.LONG]: loc ? setPrecision(loc.lng()) : null,
                    [Constants.POSTAL]: postal,
                    [Constants.REGION]: region,
                };
                document.dispatchEvent(new CustomEvent('fd:regionMismatch', {
                    detail: { country: detectedCountry }
                }));
                return cb(null, { mismatch: true, detectedCountry, [CookieNames.USER_LOCATION]: mismatchData });
            }
        }
        let locationData = {};
        const geometry = result[0].geometry;
        if (geometry && geometry.location) {
            const location = geometry.location;
            locationData = {
                [Constants.COUNTRY]: country,
                [Constants.LANGUAGE]: 'en-' + country,
                [Constants.LAT]: setPrecision(location.lat()),
                [Constants.LONG]: setPrecision(location.lng()),
                [Constants.CITY]: city,
                [Constants.REGION]: region,
                [Constants.POSTAL]: postal
            };
        }
        cookie.set(CookieNames.USER_LOCATION, serialize(locationData), CookieOpts);
        cookie.set(CookieNames.AKAMAI_ZIP, false, CookieOpts);
        cb(null, { [CookieNames.USER_LOCATION]: locationData });
    });
}
function html5Geolocate(cb) {
    if (!navigator.geolocation) {
        debugLog.warn(Errors.BROWSER_UNSUPPORTED);
    }
    function onSuccess(results) {
        setUserLocationCookie(results, cb);
    }
    const opts = {
        timeout: GeolocateOpts.timeout
    };
    navigator.geolocation.getCurrentPosition(onSuccess, cb, opts);
}
function getZip(cb) {
    const location = getUserLocation() || null;
    if (location.postal && cookie.get(CookieNames.AKAMAI_ZIP) === 'true') {
        html5Geolocate();
        return cb(null, location.postal);
    }
    else if (location.postal) {
        return cb(null, location.postal);
    }
    cb(null, null);
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    getAddressComponent,
    getCookieDomain,
    getLocationComponents,
    getUserLocation,
    getZip,
    parseCurrentCountry,
    setUserLocationCookie,
    validateLocation,
    errors: Errors,
    html5Geolocate,
};
extendLegacy('geolocator', module.exports);
export default module.exports;